var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var ALLOWED_DATEPICKER_FORMATS = new Set(['DD/MM/YYYY', 'MM/DD/YYYY']);
export var ALLOWED_DATETIMEPICKER_FORMATS = new Set([
    'DD/MM/YYYY HH:mm',
    'MM/DD/YYYY HH:mm',
]);
export var ALLOWED_DATETIMEPICKER_FORMATS_12HOUR = new Set([
    'DD/MM/YYYY hh:mm A',
    'MM/DD/YYYY hh:mm A',
]);
export var ALLOWED_DATETIMEPICKER_WITHSECONDS_FORMATS = new Set([
    'DD/MM/YYYY HH:mm:ss',
    'MM/DD/YYYY HH:mm:ss',
]);
export var ALLOWED_DATETIMEPICKER_WITHSECONDS_FORMATS_12HOUR = new Set(['DD/MM/YYYY hh:mm:ss A', 'MM/DD/YYYY hh:mm:ss A']);
export var DATEPICKER_INFINITY = 'INFINITY';
export var DatePickerQuickSelectPresets;
(function (DatePickerQuickSelectPresets) {
    DatePickerQuickSelectPresets["TODAY"] = "TODAY";
    DatePickerQuickSelectPresets["START_OF_NEXT_WEEK"] = "START_OF_NEXT_WEEK";
    DatePickerQuickSelectPresets["START_OF_TWO_WEEKS_FROM_NOW"] = "START_OF_TWO_WEEKS_FROM_NOW";
    DatePickerQuickSelectPresets["START_OF_NEXT_MONTH"] = "START_OF_NEXT_MONTH";
    DatePickerQuickSelectPresets["START_OF_NEXT_QUARTER"] = "START_OF_NEXT_QUARTER";
})(DatePickerQuickSelectPresets || (DatePickerQuickSelectPresets = {}));
export var DatePickerQuickSelectRangePresets;
(function (DatePickerQuickSelectRangePresets) {
    DatePickerQuickSelectRangePresets["THIS_WEEK"] = "THIS_WEEK";
    DatePickerQuickSelectRangePresets["NEXT_WEEK"] = "NEXT_WEEK";
    DatePickerQuickSelectRangePresets["NEXT_TWO_WEEKS"] = "NEXT_TWO_WEEKS";
    DatePickerQuickSelectRangePresets["NEXT_SIXTY_DAYS"] = "NEXT_SIXTY_DAYS";
    DatePickerQuickSelectRangePresets["NEXT_NINETY_DAYS"] = "NEXT_NINETY_DAYS";
})(DatePickerQuickSelectRangePresets || (DatePickerQuickSelectRangePresets = {}));
export var DatePickerAllQuickSelectPresetsSet = new Set(__spreadArray(__spreadArray([], __read(Object.values(DatePickerQuickSelectPresets)), false), __read(Object.values(DatePickerQuickSelectRangePresets)), false));
